import { render } from "./ChainPage.vue?vue&type=template&id=5ceca87f&scoped=true"
import script from "./ChainPage.vue?vue&type=script&lang=js"
export * from "./ChainPage.vue?vue&type=script&lang=js"

import "./ChainPage.vue?vue&type=style&index=0&id=5ceca87f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceca87f"]])

export default __exports__